import { graphql } from '@prophecy/graphql-types/graphql';
export const fetchSQLAppList = graphql(`
  query SQLUserAppList($userId: String!) {
    User(uid: $userId) {
      sqlBusinessApps {
        _id
        name
        description
        created
        createdBy
        project {
          _id
          name
        }
        sqlOrchestrationPipeline {
          _id
          name
        }
      }
    }
  }
`);
